import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class SchoolCalendarUtilService {

    public static getDateRangeQueryForUnavailableDates(fromDate: NgbDateStruct, toDate: NgbDateStruct): string {
        let fromDateTerm: String;
        let toDateTerm: String;

        if (fromDate) {
            let fromMonth: number = fromDate.month;
            let fromDay: number = fromDate.day;

            fromDateTerm = fromDate.year + '-'
                + (fromMonth < 10 ? '0' + fromMonth : fromMonth)
                + '-' + (fromDay < 10 ? '0' + fromDay : fromDay);

        } else {
            fromDateTerm = '*';
        }

        if (toDate) {
            let realToDate = new Date(toDate.year, toDate.month - 1, toDate.day);
            realToDate.setDate(realToDate.getDate());
            let toDay = realToDate.getDate();
            let toMonth = realToDate.getMonth() + 1 ;
            toDateTerm = realToDate.getFullYear() + '-'
                + (toMonth < 10 ? '0' + toMonth : toMonth )
                + '-'  + (toDay < 10 ? '0' + toDay : toDay);
        } else {
            toDateTerm = '*';
        }

        return 'begining:[ ' + fromDateTerm + ' TO ' + toDateTerm + ']';
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar.util.service.ts